import { useEffect, useState } from 'react';
import DOMPurify from 'dompurify';
import MarkdownIt from 'markdown-it';

const md = new MarkdownIt();

interface MarkdownProps {
  markdownText: string;
  setMarkup: (v: string) => void;
}

export const Markdown = ({ markdownText, setMarkup }: MarkdownProps) => {
  const [htmlContent, setHtmlContent] = useState('');

  useEffect(() => {
    const generateHtml = async () => {
      const rawMarkup = md.render(markdownText);
      const sanitizedMarkup = DOMPurify.sanitize(rawMarkup);
      setHtmlContent(sanitizedMarkup);
      setMarkup(sanitizedMarkup);
    };

    generateHtml();
  }, [markdownText, setMarkup]);

  return <div dangerouslySetInnerHTML={{ __html: htmlContent }} />;
};
